// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1Xehb","empty":"ModalGraph_empty__2ui8V"};